export type { SessionAvatarProps } from './SessionAvatar'
export { SessionAvatar } from './SessionAvatar'
